import { formatRecommendedAges } from '../helpers/helpers'

/** Place cards. Not implemented as components, but used as such in different parts of the web */
export function displayPlaceItem (place) {
  const link = `/places/${place.slug}`
  const formattedAddress = place.is_online ? 'ONLINE' : place.address ? `${place.address}, ${place.municipality}` : `${place.municipality}`

  return `
    <div class="places-list-item-wrapper horizontal">
      <div id="${place.name}" class="places-list-grid-item">
        <a href="${link}" target="_parent">
          <div class="place-item-info-container">
            <img class="place-item-image" src="${place.main_image || (place.images?.main?.url) || place.rating_category.default_image_1}" alt="${place.slug}">
            <div class="place-item-info-first">
              <h2 class="place-item-name">${place.name}</h2>
              <div class="place-item-info-second">
                <span class="place-item-category">
                  ${place.rating_category.logo ? `<img src="${place.rating_category.logo}" alt="${place.rating_category.meta_description}" width="16" height="16">` : ''}
                  ${place.rating_category.human_name}
                </span>
                <span class="place-item-age">
                  <i class="fas fa-child"></i>${formatRecommendedAges(JSON.parse(place.recommended_ages))}
                </span>
              </div>
              <p class="place-item-address">
                <i class="fas fa-map-marker-alt"></i>
                ${formattedAddress}
              </p>
            </div>
            ${place.rating ? `<h1 class="place-item-rating">${Math.round(place.rating)}<span>/100</span></h1>` : ''}
          </div>
          ${place.has_activities || place.external_booking ? '<div id="place-item-book">Reserva</div>' : ''}
        </a>
      </div>
    </div>
    `
}
